import React from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { Row, Col, Card, Select, Input, InputNumber, Form } from 'antd';
import ShelfLevelView from '@/components/shelf-level-view';

import './index.less';

export const setCommitButtonDisabled = (disabled) => {
  const commitButton = document.getElementById('commit-button');
  if (!commitButton) return;
  commitButton.disabled = disabled;
};

class ActionPanel extends React.Component {
  constructor(props) {
    super(props);

    props.forwardedRef && props.forwardedRef(this);
    this.actionFormRef = React.createRef();
  }

  getActionRequest = () => {
    const { isNetwork, simActions } = this.props;
    const { action, ...actionRequestParams } = this.actionFormRef.current.getFieldsValue(true);

    return Object.assign(isNetwork ? {} : { vd_id: simActions.vd_id }, {
      request_id: simActions.request_id,
      action,
      actionRequestParams,
    });
  };

  resetActionRequest = () => {
    this.actionFormRef.current.resetFields();
  };

  renderActions = (actions = {}) => {
    const responseValueParam = actions.responseValueParam;

    if (!responseValueParam) {
      setCommitButtonDisabled(false);
      return null;
    }

    if (this.actionFormRef.current) {
      // clear form values after form rendering completes
      const value = this.actionFormRef.current.getFieldValue(responseValueParam);

      if (isEmpty(value) || (actions.data && isEmpty(actions.data[value]))) {
        const newValue = actions.previousSelection ? actions.previousSelection.value : undefined;

        if (value !== newValue) {
          setTimeout(() => {
            isEmpty(newValue) && setCommitButtonDisabled(true);
            this.actionFormRef.current.setFieldValue(responseValueParam, newValue);
          });
        }
      }
    }

    return (
      <Form.Item
        shouldUpdate={(prevValue, curValue) =>
          prevValue[responseValueParam] !== curValue[responseValueParam]
        }
      >
        {({ getFieldValue }) => {
          const value = getFieldValue(responseValueParam);

          let formItemProps = {};
          if (actions.dataContainer === 'pullDownList') {
            formItemProps.children = (
              <Select
                placeholder={actions.sectionLabel}
                options={Object.keys(actions.data).map((key) => ({
                  label: actions.data[key],
                  value: key,
                }))}
              />
            );
          } else if (actions.dataContainer === 'textBox') {
            const isNumType = actions.validation.type === 'double';

            formItemProps.rules = [
              {
                ...actions.validation,
                type: isNumType ? 'number' : (actions.validation.type || 'string').toLowerCase(),
              },
            ];

            formItemProps.children = isNumType ? (
              <InputNumber placeholder={actions.sectionLabel} />
            ) : (
              <Input placeholder={actions.sectionLabel} />
            );
          }

          return (
            <>
              <Form.Item
                labelAlign="left"
                labelCol={{ span: 7 }}
                tooltip={actions.comment}
                name={responseValueParam}
                label={actions.dataContainerlabel}
                {...formItemProps}
              />
              {isEmpty(value) ? setCommitButtonDisabled(true) : this.renderActions(actions[value])}
            </>
          );
        }}
      </Form.Item>
    );
  };

  render() {
    const { simActions, inventory, dispatch } = this.props;

    return (
      <Row
        wrap={false}
        gutter={[16, 16]}
        className="cols-container"
      >
        <Col
          flex={1}
          style={{ minWidth: 250 }}
        >
          <Card
            type="inner"
            title={
              inventory.inventoryStatuses
                ? `Inventory Modules: ${
                    inventory.inventoryStatuses.filter(({ status }) => status === 'EMPTY').length
                  }/${inventory.inventoryStatuses.length} Available`
                : 'Inventory n/a'
            }
          >
            {(inventory.inventoryStatuses || []).map((item, index) => (
              <div
                key={`inventory-${index}`}
                className="inventory-item"
              >
                <span
                  className={classNames(
                    'inventory-status',
                    `status-${item.status}`,
                    `configstate-${item.configstate}`
                  )}
                />
                <span>
                  {item.label + item.separator + item.location + item.separator}
                  <span className={classNames('configstate', item.configstate)}>
                    {item.configstate}
                  </span>
                </span>
              </div>
            ))}
          </Card>
        </Col>
        <Col
          flex={2}
          style={{ minWidth: 350 }}
        >
          <Card
            type="inner"
            title="Action"
          >
            <Form
              labelWrap
              ref={this.actionFormRef}
            >
              {this.renderActions(simActions.actions || simActions.networkActions)}
            </Form>
          </Card>
        </Col>
        {simActions.actions && !simActions.vd_id.includes('Navigator') && (
          <Col style={{ width: '100vw' }}>
            <ShelfLevelView
              dispatch={dispatch}
              simActions={simActions}
              onSLVActionSelect={(values) => {
                this.actionFormRef.current.setFieldsValue(values);
              }}
            />
          </Col>
        )}
      </Row>
    );
  }
}

export default ActionPanel;
